/**
 * A stored tool part (the persisted `{type:'tool', tool, callID, state}` shape
 * the message API returns) → the fields a tool row renders.
 *
 * ONE mapping for every surface that reads stored parts: the main transcript
 * (`mapApiPartToUi` in hooks.ts) and the expanded helper view in
 * ToolCallBlock.tsx (#839), so a step can never read one status in the chat
 * and another in the helper view. Pure and side-effect-free on purpose — the
 * row module must not pull in the session hook's imports.
 */
export type ToolRowStatus = 'pending' | 'running' | 'completed' | 'error'

export interface ApiToolPartRow {
  callId: string
  toolName: string
  input: Record<string, unknown>
  status: ToolRowStatus
  title?: string
  metadata?: Record<string, unknown>
  /** Present only for a completed call with a stored output. */
  output?: string
  /** Present only for a failed call with a stored error. */
  error?: string
}

export function apiToolPartToRow(p: any): ApiToolPartRow {
  const st = p?.state?.status
  const status: ToolRowStatus = st === 'completed' ? 'completed' : st === 'error' ? 'error' : st === 'running' ? 'running' : 'pending'
  return {
    callId: p?.callID || '',
    toolName: p?.tool || '',
    input: p?.state?.input || {},
    status,
    title: p?.state?.title,
    metadata: p?.state?.metadata,
    output: status === 'completed' && p.state.output != null ? p.state.output : undefined,
    error: status === 'error' && p.state.error ? p.state.error : undefined,
  }
}
